// DB: {"choices": {"bila": {"cs_CZ": "bílá"}, "cira": {"cs_CZ": "čirá"}, "seda": {"cs_CZ": "šedá"}, "cerna": {"cs_CZ": "černá"}, "hneda": {"cs_CZ": "hnědá"}, "modra": {"cs_CZ": "modrá"}, "zlata": {"cs_CZ": "zlatá"}, "zluta": {"cs_CZ": "žlutá"}, "bezova": {"cs_CZ": "béžová"}, "medena": {"cs_CZ": "měděná"}, "ruzova": {"cs_CZ": "růžová"}, "zelena": {"cs_CZ": "zelená"}, "cervena": {"cs_CZ": "červená"}, "fialova": {"cs_CZ": "fialová"}, "kremova": {"cs_CZ": "krémová"}, "piskova": {"cs_CZ": "písková"}, "oranzova": {"cs_CZ": "oranžová"}, "stribrna": {"cs_CZ": "stříbrná"}, "tyrkysova": {"cs_CZ": "tyrkysová"}, "nezarazeno": {"cs_CZ": "nezařazeno"}}, "multiple": false}

export const colorCodeMap = {
  bila: '#FFFFFF', // bílá - white
  cira: '#FFFFFF', // čirá - clear/transparent
  seda: '#808080', // šedá - gray
  cerna: '#000000', // černá - black
  hneda: '#8B4513', // hnědá - brown
  modra: '#0000FF', // modrá - blue
  zlata: '#FFD700', // zlatá - gold
  zluta: '#FFFF00', // žlutá - yellow
  bezova: '#F5F5DC', // béžová - beige
  medena: '#B87333', // měděná - copper
  ruzova: '#FFC0CB', // růžová - pink
  zelena: '#008000', // zelená - green
  cervena: '#FF0000', // červená - red
  fialova: '#800080', // fialová - purple
  kremova: '#FFFDD0', // krémová - cream
  piskova: '#C2B280', // písková - sand
  oranzova: '#FFA500', // oranžová - orange
  stribrna: '#C0C0C0', // stříbrná - silver
  tyrkysova: '#40E0D0', // tyrkysová - turquoise
  nezarazeno: '#D3D3D3', // nezařazeno - unclassified (light gray)
} as const;

export type ColorCode = keyof typeof colorCodeMap;

export function isValidColorCode(code: string): code is ColorCode {
  return code in colorCodeMap;
}
